export default __webpack_public_path__ + "static/media/sticker-d.02153ccf.png";